export const uk = {
    'common-error-update-regions': 'Ошибка обновления регионов показа',
    'link-message-groups': 'Посмотреть'
};
